import {
  NumericFormat as NumericFormatInner,
  NumericFormatProps as NumericFormatPropsInner,
} from 'react-number-format';

export type NumericFormatProps = Omit<
  NumericFormatPropsInner,
  'onValueChange'
> & {
  id?: string;
  value?: number | string | null;
  onChange?: (value: string) => void;
  onValueChange?: NumericFormatPropsInner['onValueChange'];
};

export const NumericFormat = ({
  id,
  value,
  onChange,
  onValueChange,
  ...rest
}: NumericFormatProps) => {
  return (
    <NumericFormatInner
      id={id}
      value={value ?? ''}
      valueIsNumericString={typeof value === 'string'}
      onValueChange={(values, sourceInfo) => {
        if (sourceInfo.source !== 'event') {
          return;
        }

        onChange?.(values.formattedValue);
        onValueChange?.(values, sourceInfo);
      }}
      {...rest}
    />
  );
};
